// Generated by tools/gen-tag-icons.mjs from simple-icons — the brand logos Font Awesome lacks.
// Do not edit by hand; re-run the generator after changing the icon list.
export interface TagIcon { viewBox: string; body: string }
export const TAG_ICONS: Record<string, TagIcon> = {
  "gumroad": { viewBox: "0 0 24 24", body: "<path fill=\"currentColor\" d=\"M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12a12 12 0 0 0 12-12A12 12 0 0 0 12 0m-.007 5.12c4.48 0 5.995 3.025 6.064 4.744h-3.239c-.069-.962-.897-2.406-2.896-2.406c-2.136 0-3.514 1.857-3.514 4.126s1.378 4.125 3.514 4.125c1.93 0 2.758-1.512 3.103-3.025h-3.103v-1.238h6.509v6.327h-2.855v-3.989c-.207 1.444-1.102 4.264-4.617 4.264c-3.516 0-5.584-2.82-5.584-6.326c0-3.645 2.276-6.602 6.618-6.602\"/>" }
};
export function brandIcon(key: string): string {
    const icon = TAG_ICONS[key];
    return icon ? `<svg class="tag-icon" viewBox="${icon.viewBox}" aria-hidden="true">${icon.body}</svg>` : '';
}
